import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "@/components/Shared";

export default function CtaBand() {
  const navigate = useNavigate();

  return (
    <section data-testid="cta-band-section" className="py-24 md:py-32">
      <div className="container-x">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border hairline bg-card px-8 py-16 text-center md:px-16 md:py-24">
            <div
              className="pointer-events-none absolute inset-0"
              aria-hidden="true"
              style={{
                background:
                  "radial-gradient(60% 90% at 50% 0%, rgba(229,231,235,0.08) 0%, rgba(156,163,175,0.03) 45%, transparent 75%)",
              }}
            />
            <div className="relative">
              <p className="eyebrow">Let's Build Something</p>
              <h2 className="mx-auto mt-6 max-w-3xl font-grotesk text-3xl font-semibold tracking-tight text-txt sm:text-4xl lg:text-5xl">
                Ready to move your business{" "}
                <span className="grad-text">forward?</span>
              </h2>
              <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-sub">
                Tell us about the website you need, the tech troubles you are
                facing, or the idea you have been sitting on. We will reply with
                clear, practical next steps.
              </p>
              <button
                type="button"
                data-testid="cta-band-button"
                onClick={() => navigate("/contact")}
                className="btn-primary mt-10"
              >
                Let's Build Something
                <ArrowUpRight className="h-4 w-4" strokeWidth={2.5} />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
